<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Language</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="container-center lg animated fadeIn">
      <nav id="nav">
        <ul class="nav">
          <li class="pointer">
            <a v-on:click="setLang('en')">
              English
              <span class="nav-icon">
                <span v-if="$i18n.locale == 'en'">
                  <i class="fad fa-check"></i>
                </span>
              </span>
            </a>
          </li>
          <li class="pointer hidden">
            <a v-on:click="setLang('ko')">
              한국어
              <span class="nav-icon">
                <span v-if="$i18n.locale == 'ko'">
                  <i class="fad fa-check"></i>
                </span>
              </span>
            </a>
          </li>
          <li class="pointer">
            <a v-on:click="setLang('th')">
              ภาษาไทย
              <span class="nav-icon">
                <span v-if="$i18n.locale == 'th'">
                  <i class="fad fa-check"></i>
                </span>
              </span>
            </a>
          </li>
          <li class="pointer">
            <a v-on:click="setLang('jp')">
              日本語
              <span class="nav-icon">
                <span v-if="$i18n.locale == 'jp'">
                  <i class="fad fa-check"></i>
                </span>
              </span>
            </a>
          </li>
          <li class="pointer">
            <a v-on:click="setLang('zhcn')">
              中文(简体)
              <span class="nav-icon">
                <span v-if="$i18n.locale == 'zhcn'">
                  <i class="fad fa-check"></i>
                </span>
              </span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setLang(lang) {
      localStorage.setItem("Lang", lang);
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style scoped>
.nav a {
  color: #949ba2;
  background: #1d1f24;
  margin-bottom: 5px;
}
.nav > li > a:focus,
.nav > li > a:hover {
  text-decoration: none;
  background-color: #2c313c;
}
.nav {
  margin-bottom: 10px;
}
.nav-icon {
  float: right;
}
.fas {
  width: 22px;
}
</style>
